/* Options:
Date: 2022-06-09 17:15:18
Version: 5.120
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:44335

//GlobalNamespace:
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion:
//AddDescriptionAsComments: True
//IncludeTypes:
//ExcludeTypes:
//DefaultImports:
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var BaseRequest = /** @class */ (function () {
    function BaseRequest(init) {
        Object.assign(this, init);
    }
    return BaseRequest;
}());
export { BaseRequest };
var BaseGeneric = /** @class */ (function () {
    function BaseGeneric(init) {
        Object.assign(this, init);
    }
    return BaseGeneric;
}());
export { BaseGeneric };
var Fund = /** @class */ (function (_super) {
    __extends(Fund, _super);
    function Fund(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return Fund;
}(BaseGeneric));
export { Fund };
var FileInfo = /** @class */ (function () {
    function FileInfo(init) {
        Object.assign(this, init);
    }
    return FileInfo;
}());
export { FileInfo };
var FundP = /** @class */ (function (_super) {
    __extends(FundP, _super);
    function FundP(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return FundP;
}(BaseGeneric));
export { FundP };
var ArticleCategory = /** @class */ (function (_super) {
    __extends(ArticleCategory, _super);
    function ArticleCategory(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return ArticleCategory;
}(BaseGeneric));
export { ArticleCategory };
var Category = /** @class */ (function (_super) {
    __extends(Category, _super);
    function Category(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return Category;
}(BaseGeneric));
export { Category };
// @DataContract
var ResponseError = /** @class */ (function () {
    function ResponseError(init) {
        Object.assign(this, init);
    }
    return ResponseError;
}());
export { ResponseError };
// @DataContract
var ResponseStatus = /** @class */ (function () {
    function ResponseStatus(init) {
        Object.assign(this, init);
    }
    return ResponseStatus;
}());
export { ResponseStatus };
var BaseResponse = /** @class */ (function () {
    function BaseResponse(init) {
        Object.assign(this, init);
    }
    return BaseResponse;
}());
export { BaseResponse };
var Dividend = /** @class */ (function (_super) {
    __extends(Dividend, _super);
    function Dividend(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return Dividend;
}(BaseGeneric));
export { Dividend };
var FundPDivid = /** @class */ (function () {
    function FundPDivid(init) {
        Object.assign(this, init);
    }
    return FundPDivid;
}());
export { FundPDivid };
var FundNAV = /** @class */ (function () {
    function FundNAV(init) {
        Object.assign(this, init);
    }
    return FundNAV;
}());
export { FundNAV };
var Estimate = /** @class */ (function () {
    function Estimate(init) {
        Object.assign(this, init);
    }
    return Estimate;
}());
export { Estimate };
var Stock = /** @class */ (function () {
    function Stock(init) {
        Object.assign(this, init);
    }
    return Stock;
}());
export { Stock };
var IndexChange = /** @class */ (function () {
    function IndexChange(init) {
        Object.assign(this, init);
    }
    return IndexChange;
}());
export { IndexChange };
var ETF = /** @class */ (function () {
    function ETF(init) {
        Object.assign(this, init);
    }
    return ETF;
}());
export { ETF };
var Cash = /** @class */ (function () {
    function Cash(init) {
        Object.assign(this, init);
    }
    return Cash;
}());
export { Cash };
var Margin = /** @class */ (function () {
    function Margin(init) {
        Object.assign(this, init);
    }
    return Margin;
}());
export { Margin };
var Futures = /** @class */ (function () {
    function Futures(init) {
        Object.assign(this, init);
    }
    return Futures;
}());
export { Futures };
var LPFund = /** @class */ (function () {
    function LPFund(init) {
        Object.assign(this, init);
    }
    return LPFund;
}());
export { LPFund };
// @DataContract
var CurrencyV = /** @class */ (function () {
    function CurrencyV(init) {
        Object.assign(this, init);
    }
    return CurrencyV;
}());
export { CurrencyV };
// @Flags()
export var CacheControl;
(function (CacheControl) {
    CacheControl[CacheControl["None"] = 0] = "None";
    CacheControl[CacheControl["Public"] = 1] = "Public";
    CacheControl[CacheControl["Private"] = 2] = "Private";
    CacheControl[CacheControl["MustRevalidate"] = 4] = "MustRevalidate";
    CacheControl[CacheControl["NoCache"] = 8] = "NoCache";
    CacheControl[CacheControl["NoStore"] = 16] = "NoStore";
    CacheControl[CacheControl["NoTransform"] = 32] = "NoTransform";
    CacheControl[CacheControl["ProxyRevalidate"] = 64] = "ProxyRevalidate";
})(CacheControl || (CacheControl = {}));
var Article = /** @class */ (function (_super) {
    __extends(Article, _super);
    function Article(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return Article;
}(BaseGeneric));
export { Article };
export var SitemapFrequency;
(function (SitemapFrequency) {
    SitemapFrequency["Always"] = "Always";
    SitemapFrequency["Hourly"] = "Hourly";
    SitemapFrequency["Daily"] = "Daily";
    SitemapFrequency["Weekly"] = "Weekly";
    SitemapFrequency["Monthly"] = "Monthly";
    SitemapFrequency["Yearly"] = "Yearly";
    SitemapFrequency["Never"] = "Never";
})(SitemapFrequency || (SitemapFrequency = {}));
var SitemapUrl = /** @class */ (function () {
    function SitemapUrl(init) {
        Object.assign(this, init);
    }
    return SitemapUrl;
}());
export { SitemapUrl };
var AD = /** @class */ (function (_super) {
    __extends(AD, _super);
    function AD(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return AD;
}(BaseGeneric));
export { AD };
var PingResponse = /** @class */ (function () {
    function PingResponse(init) {
        Object.assign(this, init);
    }
    return PingResponse;
}());
export { PingResponse };
var FundResponse = /** @class */ (function (_super) {
    __extends(FundResponse, _super);
    function FundResponse(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return FundResponse;
}(BaseResponse));
export { FundResponse };
var DividendResponse = /** @class */ (function (_super) {
    __extends(DividendResponse, _super);
    function DividendResponse(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return DividendResponse;
}(BaseResponse));
export { DividendResponse };
var NavResponse = /** @class */ (function () {
    function NavResponse(init) {
        Object.assign(this, init);
    }
    return NavResponse;
}());
export { NavResponse };
var EstimateResponse = /** @class */ (function (_super) {
    __extends(EstimateResponse, _super);
    function EstimateResponse(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return EstimateResponse;
}(BaseResponse));
export { EstimateResponse };
var PCFResponse = /** @class */ (function (_super) {
    __extends(PCFResponse, _super);
    function PCFResponse(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return PCFResponse;
}(BaseResponse));
export { PCFResponse };
var IndexChangeResponse = /** @class */ (function (_super) {
    __extends(IndexChangeResponse, _super);
    function IndexChangeResponse(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return IndexChangeResponse;
}(BaseResponse));
export { IndexChangeResponse };
var ETFResponse = /** @class */ (function () {
    function ETFResponse(init) {
        Object.assign(this, init);
    }
    return ETFResponse;
}());
export { ETFResponse };
var LPResponse = /** @class */ (function () {
    function LPResponse(init) {
        Object.assign(this, init);
    }
    return LPResponse;
}());
export { LPResponse };
var FrontResponse = /** @class */ (function (_super) {
    __extends(FrontResponse, _super);
    function FrontResponse(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return FrontResponse;
}(BaseResponse));
export { FrontResponse };
var FrontInfoResponse = /** @class */ (function () {
    function FrontInfoResponse(init) {
        Object.assign(this, init);
    }
    return FrontInfoResponse;
}());
export { FrontInfoResponse };
var RouteResponse = /** @class */ (function () {
    function RouteResponse(init) {
        Object.assign(this, init);
    }
    return RouteResponse;
}());
export { RouteResponse };
var ADResponse = /** @class */ (function (_super) {
    __extends(ADResponse, _super);
    function ADResponse(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return ADResponse;
}(BaseResponse));
export { ADResponse };
// @DataContract
var AuthenticateResponse = /** @class */ (function () {
    function AuthenticateResponse(init) {
        Object.assign(this, init);
    }
    return AuthenticateResponse;
}());
export { AuthenticateResponse };
// @DataContract
var ConvertSessionToTokenResponse = /** @class */ (function () {
    function ConvertSessionToTokenResponse(init) {
        Object.assign(this, init);
    }
    return ConvertSessionToTokenResponse;
}());
export { ConvertSessionToTokenResponse };
// @DataContract
var GetAccessTokenResponse = /** @class */ (function () {
    function GetAccessTokenResponse(init) {
        Object.assign(this, init);
    }
    return GetAccessTokenResponse;
}());
export { GetAccessTokenResponse };
// @Route("/api/ping", "POST")
var WebSitePingRequest = /** @class */ (function () {
    function WebSitePingRequest(init) {
        Object.assign(this, init);
    }
    WebSitePingRequest.prototype.createResponse = function () { return new PingResponse(); };
    WebSitePingRequest.prototype.getTypeName = function () { return 'WebSitePingRequest'; };
    return WebSitePingRequest;
}());
export { WebSitePingRequest };
// @Route("/api/WebSite/stock", "GET")
var WebSiteStockRequest = /** @class */ (function () {
    function WebSiteStockRequest(init) {
        Object.assign(this, init);
    }
    WebSiteStockRequest.prototype.createResponse = function () { return new FundResponse(); };
    WebSiteStockRequest.prototype.getTypeName = function () { return 'WebSiteStockRequest'; };
    return WebSiteStockRequest;
}());
export { WebSiteStockRequest };
// @Route("/api/WebSite/stockList", "GET")
var WebSiteStockListRequest = /** @class */ (function () {
    function WebSiteStockListRequest(init) {
        Object.assign(this, init);
    }
    WebSiteStockListRequest.prototype.createResponse = function () { return new FundResponse(); };
    WebSiteStockListRequest.prototype.getTypeName = function () { return 'WebSiteStockListRequest'; };
    return WebSiteStockListRequest;
}());
export { WebSiteStockListRequest };
// @Route("/api/WebSite/stockDividend", "GET")
var WebSiteStockDividendRequest = /** @class */ (function () {
    function WebSiteStockDividendRequest(init) {
        Object.assign(this, init);
    }
    WebSiteStockDividendRequest.prototype.createResponse = function () { return new DividendResponse(); };
    WebSiteStockDividendRequest.prototype.getTypeName = function () { return 'WebSiteStockDividendRequest'; };
    return WebSiteStockDividendRequest;
}());
export { WebSiteStockDividendRequest };
// @Route("/api/WebSite/stockPrice", "GET")
var WebSiteStockPriceRequest = /** @class */ (function () {
    function WebSiteStockPriceRequest(init) {
        Object.assign(this, init);
    }
    WebSiteStockPriceRequest.prototype.createResponse = function () { return new NavResponse(); };
    WebSiteStockPriceRequest.prototype.getTypeName = function () { return 'WebSiteStockPriceRequest'; };
    return WebSiteStockPriceRequest;
}());
export { WebSiteStockPriceRequest };
// @Route("/api/WebSite/estimate", "GET")
var WebSiteEstimateRequest = /** @class */ (function () {
    function WebSiteEstimateRequest(init) {
        Object.assign(this, init);
    }
    WebSiteEstimateRequest.prototype.createResponse = function () { return new EstimateResponse(); };
    WebSiteEstimateRequest.prototype.getTypeName = function () { return 'WebSiteEstimateRequest'; };
    return WebSiteEstimateRequest;
}());
export { WebSiteEstimateRequest };
// @Route("/api/WebSite/pcf", "GET")
var WebSitePcfRequest = /** @class */ (function () {
    function WebSitePcfRequest(init) {
        Object.assign(this, init);
    }
    WebSitePcfRequest.prototype.createResponse = function () { return new PCFResponse(); };
    WebSitePcfRequest.prototype.getTypeName = function () { return 'WebSitePcfRequest'; };
    return WebSitePcfRequest;
}());
export { WebSitePcfRequest };
// @Route("/api/WebSite/indexChange", "GET")
var WebSiteIndexChangeRequest = /** @class */ (function () {
    function WebSiteIndexChangeRequest(init) {
        Object.assign(this, init);
    }
    WebSiteIndexChangeRequest.prototype.createResponse = function () { return new IndexChangeResponse(); };
    WebSiteIndexChangeRequest.prototype.getTypeName = function () { return 'WebSiteIndexChangeRequest'; };
    return WebSiteIndexChangeRequest;
}());
export { WebSiteIndexChangeRequest };
// @Route("/api/WebSite/ETF", "GET")
var WebSiteETFRequest = /** @class */ (function () {
    function WebSiteETFRequest(init) {
        Object.assign(this, init);
    }
    WebSiteETFRequest.prototype.createResponse = function () { return new ETFResponse(); };
    WebSiteETFRequest.prototype.getTypeName = function () { return 'WebSiteETFRequest'; };
    return WebSiteETFRequest;
}());
export { WebSiteETFRequest };
// @Route("/api/WebSite/LP", "GET")
var WebSiteLPRequest = /** @class */ (function () {
    function WebSiteLPRequest(init) {
        Object.assign(this, init);
    }
    WebSiteLPRequest.prototype.createResponse = function () { return new LPResponse(); };
    WebSiteLPRequest.prototype.getTypeName = function () { return 'WebSiteLPRequest'; };
    return WebSiteLPRequest;
}());
export { WebSiteLPRequest };
// @Route("/api/WebSite/fundSizeList", "GET")
var WebSitefundSizeListRequest = /** @class */ (function () {
    function WebSitefundSizeListRequest(init) {
        Object.assign(this, init);
    }
    WebSitefundSizeListRequest.prototype.createResponse = function () { return new FundResponse(); };
    WebSitefundSizeListRequest.prototype.getTypeName = function () { return 'WebSitefundSizeListRequest'; };
    return WebSitefundSizeListRequest;
}());
export { WebSitefundSizeListRequest };
// @Route("/api/WebSite/Front", "GET")
var WebSiteFrontRequest = /** @class */ (function () {
    function WebSiteFrontRequest(init) {
        Object.assign(this, init);
    }
    WebSiteFrontRequest.prototype.createResponse = function () { return new FrontResponse(); };
    WebSiteFrontRequest.prototype.getTypeName = function () { return 'WebSiteFrontRequest'; };
    return WebSiteFrontRequest;
}());
export { WebSiteFrontRequest };
// @Route("/api/WebSite/Front/footer", "GET")
var WebSiteFrontFooterRequest = /** @class */ (function () {
    function WebSiteFrontFooterRequest(init) {
        Object.assign(this, init);
    }
    WebSiteFrontFooterRequest.prototype.createResponse = function () { return new FrontInfoResponse(); };
    WebSiteFrontFooterRequest.prototype.getTypeName = function () { return 'WebSiteFrontFooterRequest'; };
    return WebSiteFrontFooterRequest;
}());
export { WebSiteFrontFooterRequest };
// @Route("/api/WebSite/SiteMap", "GET")
var WebSiteSiteMapRequest = /** @class */ (function () {
    function WebSiteSiteMapRequest(init) {
        Object.assign(this, init);
    }
    WebSiteSiteMapRequest.prototype.createResponse = function () { return new Array(); };
    WebSiteSiteMapRequest.prototype.getTypeName = function () { return 'WebSiteSiteMapRequest'; };
    return WebSiteSiteMapRequest;
}());
export { WebSiteSiteMapRequest };
// @Route("/api/WebSite/RouteMap", "GET")
var WebSiteRouteMapRequest = /** @class */ (function () {
    function WebSiteRouteMapRequest(init) {
        Object.assign(this, init);
    }
    WebSiteRouteMapRequest.prototype.createResponse = function () { return new RouteResponse(); };
    WebSiteRouteMapRequest.prototype.getTypeName = function () { return 'WebSiteRouteMapRequest'; };
    return WebSiteRouteMapRequest;
}());
export { WebSiteRouteMapRequest };
// @Route("/api/WebSite/ad", "GET")
var WebSiteADRequest = /** @class */ (function () {
    function WebSiteADRequest(init) {
        Object.assign(this, init);
    }
    WebSiteADRequest.prototype.createResponse = function () { return new ADResponse(); };
    WebSiteADRequest.prototype.getTypeName = function () { return 'WebSiteADRequest'; };
    return WebSiteADRequest;
}());
export { WebSiteADRequest };
// @Route("/api/WebSite/SEO/reset", "GET")
var WebSiteResetRequest = /** @class */ (function () {
    function WebSiteResetRequest(init) {
        Object.assign(this, init);
    }
    WebSiteResetRequest.prototype.createResponse = function () { return new PingResponse(); };
    WebSiteResetRequest.prototype.getTypeName = function () { return 'WebSiteResetRequest'; };
    return WebSiteResetRequest;
}());
export { WebSiteResetRequest };
// @Route("/api/WebSite/SEO/build", "GET")
var WebSiteBuildRequest = /** @class */ (function () {
    function WebSiteBuildRequest(init) {
        Object.assign(this, init);
    }
    WebSiteBuildRequest.prototype.createResponse = function () { return new PingResponse(); };
    WebSiteBuildRequest.prototype.getTypeName = function () { return 'WebSiteBuildRequest'; };
    return WebSiteBuildRequest;
}());
export { WebSiteBuildRequest };
// @Route("/api/WebSite/SEO/create", "GET")
var WebSiteCreatRequest = /** @class */ (function () {
    function WebSiteCreatRequest(init) {
        Object.assign(this, init);
    }
    WebSiteCreatRequest.prototype.createResponse = function () { return new PingResponse(); };
    WebSiteCreatRequest.prototype.getTypeName = function () { return 'WebSiteCreatRequest'; };
    return WebSiteCreatRequest;
}());
export { WebSiteCreatRequest };
// @Route("/mq/Create", "POST")
var CreateMq = /** @class */ (function () {
    function CreateMq(init) {
        Object.assign(this, init);
    }
    CreateMq.prototype.createResponse = function () { };
    CreateMq.prototype.getTypeName = function () { return 'CreateMq'; };
    return CreateMq;
}());
export { CreateMq };
// @Route("/mq/Reset", "POST")
var ResetMq = /** @class */ (function () {
    function ResetMq(init) {
        Object.assign(this, init);
    }
    ResetMq.prototype.createResponse = function () { };
    ResetMq.prototype.getTypeName = function () { return 'ResetMq'; };
    return ResetMq;
}());
export { ResetMq };
// @Route("/test", "GET")
var WebSiteTestRequest = /** @class */ (function () {
    function WebSiteTestRequest(init) {
        Object.assign(this, init);
    }
    return WebSiteTestRequest;
}());
export { WebSiteTestRequest };
// @Route("/ServerEvent/NotifyAll", "POST")
var ServerEventNotifyAll = /** @class */ (function () {
    function ServerEventNotifyAll(init) {
        Object.assign(this, init);
    }
    ServerEventNotifyAll.prototype.createResponse = function () { return new Object(); };
    ServerEventNotifyAll.prototype.getTypeName = function () { return 'ServerEventNotifyAll'; };
    return ServerEventNotifyAll;
}());
export { ServerEventNotifyAll };
// @Route("/ServerEvent/NotifyChannel", "POST")
var ServerEventNotifyChannel = /** @class */ (function () {
    function ServerEventNotifyChannel(init) {
        Object.assign(this, init);
    }
    ServerEventNotifyChannel.prototype.createResponse = function () { return new Object(); };
    ServerEventNotifyChannel.prototype.getTypeName = function () { return 'ServerEventNotifyChannel'; };
    return ServerEventNotifyChannel;
}());
export { ServerEventNotifyChannel };
// @Route("/ServerEvent/NotifyUserId", "POST")
var ServerEventNotifyUserId = /** @class */ (function () {
    function ServerEventNotifyUserId(init) {
        Object.assign(this, init);
    }
    ServerEventNotifyUserId.prototype.createResponse = function () { return new Object(); };
    ServerEventNotifyUserId.prototype.getTypeName = function () { return 'ServerEventNotifyUserId'; };
    return ServerEventNotifyUserId;
}());
export { ServerEventNotifyUserId };
// @Route("/ServerEvent/NotifyUserName", "POST")
var ServerEventNotifyUserName = /** @class */ (function () {
    function ServerEventNotifyUserName(init) {
        Object.assign(this, init);
    }
    ServerEventNotifyUserName.prototype.createResponse = function () { return new Object(); };
    ServerEventNotifyUserName.prototype.getTypeName = function () { return 'ServerEventNotifyUserName'; };
    return ServerEventNotifyUserName;
}());
export { ServerEventNotifyUserName };
// @Route("/ServerEvent/NotifySession", "POST")
var ServerEventNotifySession = /** @class */ (function () {
    function ServerEventNotifySession(init) {
        Object.assign(this, init);
    }
    ServerEventNotifySession.prototype.createResponse = function () { return new Object(); };
    ServerEventNotifySession.prototype.getTypeName = function () { return 'ServerEventNotifySession'; };
    return ServerEventNotifySession;
}());
export { ServerEventNotifySession };
// @Route("/ggg")
var SpaFallback = /** @class */ (function (_super) {
    __extends(SpaFallback, _super);
    function SpaFallback(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return SpaFallback;
}(BaseRequest));
export { SpaFallback };
// @Route("/auth")
// @Route("/auth/{provider}")
// @DataContract
var Authenticate = /** @class */ (function () {
    function Authenticate(init) {
        Object.assign(this, init);
    }
    Authenticate.prototype.createResponse = function () { return new AuthenticateResponse(); };
    Authenticate.prototype.getTypeName = function () { return 'Authenticate'; };
    return Authenticate;
}());
export { Authenticate };
// @Route("/session-to-token")
// @DataContract
var ConvertSessionToToken = /** @class */ (function () {
    function ConvertSessionToToken(init) {
        Object.assign(this, init);
    }
    ConvertSessionToToken.prototype.createResponse = function () { return new ConvertSessionToTokenResponse(); };
    ConvertSessionToToken.prototype.getTypeName = function () { return 'ConvertSessionToToken'; };
    return ConvertSessionToToken;
}());
export { ConvertSessionToToken };
// @Route("/access-token")
// @DataContract
var GetAccessToken = /** @class */ (function () {
    function GetAccessToken(init) {
        Object.assign(this, init);
    }
    GetAccessToken.prototype.createResponse = function () { return new GetAccessTokenResponse(); };
    GetAccessToken.prototype.getTypeName = function () { return 'GetAccessToken'; };
    return GetAccessToken;
}());
export { GetAccessToken };
